import { api } from '@/services/api';
import { useMutation } from '@tanstack/react-query';
import type { ChatRequest, ChatResponse } from '@/api/experimentalApiTypes';

interface PostChatParameters extends ChatRequest {
  assetId: string;
  tenantId: string;
}

export const usePostChat = () => {
  return useMutation<ChatResponse, Error, PostChatParameters>({
    mutationFn: async (parameters: PostChatParameters) => {
      const { assetId, message, onChunk, tenantId } = parameters;
      const response = await api.assets.chat(assetId, tenantId, { message }, onChunk);
      return response.data;
    },
  });
};
